var _path, _rect, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11144 12.6668H8.88921C9.41082 12.6668 9.83366 13.0897 9.83366 13.6113C9.83366 14.0101 9.51031 14.3335 9.11144 14.3335H6.88921C6.49034 14.3335 6.16699 14.0101 6.16699 13.6113C6.16699 13.0897 6.58983 12.6668 7.11144 12.6668Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 12,
    rx: 2,
    transform: "matrix(1 0 0 -1 4 14.5)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.666667,
    cy: 0.666667,
    rx: 0.666667,
    ry: 0.666667,
    transform: "matrix(1 0 0 -1 7.33301 5.1665)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.41f88d7c.svg";
export { ForwardRef as ReactComponent };